import namespace from './namespace';

export enum ActionTypeValues {
  RESET_PAGE_STATE = 'RESET_PAGE_STATE',
  UPDATE_EMOJIES = 'UPDATE_EMOJIES',
  UPDATE_DELETEREASONS = 'UPDATE_DELETEREASONS',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
  CLEAR_ACCOUNT = 'CLEAR_ACCOUNT',
  UPDATE_TOTALREPLYS = 'UPDATE_TOTALREPLYS',
  PUBLISH_SUCCESS = 'PUBLISH_SUCCESS',
  UPDATE_APP_SENSORS = 'UPDATE_APP_SENSORS',
  UPDATE_PERMISSION = 'UPDATE_PERMISSION',
  /* 首页推荐 */
  UPDATE_HOME_CHANNEL_ACTIVE_KEYS='UPDATE_HOME_CHANNEL_ACTIVE_KEYS',
  UPDATE_HOME_CHANNEL_SORT_KEY_MAP='UPDATE_HOME_CHANNEL_SORT_KEY_MAP',
  UPDATE_HOME_ARTICAL_LIST = 'UPDATE_HOME_ARTICAL_LIST',
  UPDATE_HOME_CHANNEL_LIST = 'UPDATE_HOME_CHANNEL_LIST',
  UPDATE_HOME_BANNER_LIST = 'UPDATE_HOME_BANNER_LIST',
  UPDATE_PC_HOME_ACTIVE_CHANNEL_NAME = 'UPDATE_PC_HOME_ACTIVE_CHANNEL_NAME',
  /** 首页活动 */
  UPDATE_ACTIVITY_CHANNEL_LIST = 'UPDATE_ACTIVITY_CHANNEL_LIST',
  UPDATE_ACTIVITY_CHANNEL_ACTIVE_KEYS='UPDATE_ACTIVITY_CHANNEL_ACTIVE_KEYS',
  UPDATE_ACTIVITY_CHANNEL_SORT_KEY_MAP='UPDATE_ACTIVITY_CHANNEL_SORT_KEY_MAP',
  UPDATE_ACTIVITY_ARTICAL_LIST = 'UPDATE_ACTIVITY_ARTICAL_LIST',
  /** 首页广场 */
  UPDATE_SQUARE_CHANNEL_LIST = 'UPDATE_SQUARE_CHANNEL_LIST',
  UPDATE_SQUARE_CHANNEL_ACTIVE_KEYS='UPDATE_SQUARE_CHANNEL_ACTIVE_KEYS',
  UPDATE_SQUARE_CHANNEL_SORT_KEY_MAP='UPDATE_SQUARE_CHANNEL_SORT_KEY_MAP',
  UPDATE_SQUARE_ARTICAL_LIST = 'UPDATE_SQUARE_ARTICAL_LIST',
  /** 首页咨询 */
  UPDATE_CONSULT_CHANNEL_LIST = 'UPDATE_CONSULT_CHANNEL_LIST',
  UPDATE_CONSULT_CHANNEL_ACTIVE_KEYS='UPDATE_CONSULT_CHANNEL_ACTIVE_KEYS',
  UPDATE_CONSULT_CHANNEL_SORT_KEY_MAP='UPDATE_CONSULT_CHANNEL_SORT_KEY_MAP',
  UPDATE_CONSULT_ARTICAL_LIST = 'UPDATE_CONSULT_ARTICAL_LIST',
  /** 设备圈 */
  UPDATE_DEVICES_CHANNEL_LIST = 'UPDATE_DEVICES_CHANNEL_LIST',
  UPDATE_DEVICES_CHANNEL_ACTIVE_KEYS='UPDATE_DEVICES_CHANNEL_ACTIVE_KEYS',
  UPDATE_DEVICES_CHANNEL_SORT_KEY_MAP='UPDATE_DEVICES_CHANNEL_SORT_KEY_MAP',
  UPDATE_DEVICES_ARTICAL_LIST = 'UPDATE_DEVICES_ARTICAL_LIST',
  UPDATE_DEVICES_SERIES_NAME = 'UPDATE_DEVICES_SERIES_NAME',
  /** 设备主题 */
  UPDATE_DEVICE_CHANNEL_LIST = 'UPDATE_DEVICE_CHANNEL_LIST',
  UPDATE_DEVICE_CHANNEL_ACTIVE_KEYS='UPDATE_DEVICE_CHANNEL_ACTIVE_KEYS',
  UPDATE_DEVICE_CHANNEL_SORT_KEY_MAP='UPDATE_DEVICE_CHANNEL_SORT_KEY_MAP',
  UPDATE_DEVICE_ARTICAL_LIST = 'UPDATE_DEVICE_ARTICAL_LIST',
  UPDATE_DEVICE_NAME = 'UPDATE_DEVICE_NAME',
}

export type IAction<T> = {
  type: `${ActionTypeValues}`,
  payload?: T,
  namespace?: `${namespace}`,
}

type IActionTypes = {
  [key in namespace]: {
    [childKey in ActionTypeValues]?: `${ActionTypeValues}`
  }
}

const actionTypes: IActionTypes = {
  [namespace.app]: {
    [ActionTypeValues.RESET_PAGE_STATE]: ActionTypeValues.RESET_PAGE_STATE,
    [ActionTypeValues.UPDATE_ACCOUNT]: ActionTypeValues.UPDATE_ACCOUNT,
    [ActionTypeValues.CLEAR_ACCOUNT]: ActionTypeValues.CLEAR_ACCOUNT,
    [ActionTypeValues.UPDATE_APP_SENSORS]: ActionTypeValues.UPDATE_APP_SENSORS,
    [ActionTypeValues.UPDATE_PERMISSION]: ActionTypeValues.UPDATE_PERMISSION,
  },
  [namespace.home]: {
    [ActionTypeValues.RESET_PAGE_STATE]: ActionTypeValues.RESET_PAGE_STATE,
    [ActionTypeValues.UPDATE_HOME_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_HOME_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_HOME_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_HOME_CHANNEL_SORT_KEY_MAP,
    [ActionTypeValues.UPDATE_HOME_ARTICAL_LIST]: ActionTypeValues.UPDATE_HOME_ARTICAL_LIST,
    [ActionTypeValues.UPDATE_HOME_CHANNEL_LIST]: ActionTypeValues.UPDATE_HOME_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_HOME_BANNER_LIST]: ActionTypeValues.UPDATE_HOME_BANNER_LIST,
    [ActionTypeValues.UPDATE_PC_HOME_ACTIVE_CHANNEL_NAME]: ActionTypeValues.UPDATE_PC_HOME_ACTIVE_CHANNEL_NAME,
  },
  [namespace.activity]: {
    [ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_LIST]: ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_ACTIVITY_CHANNEL_SORT_KEY_MAP,
    [ActionTypeValues.UPDATE_ACTIVITY_ARTICAL_LIST]: ActionTypeValues.UPDATE_ACTIVITY_ARTICAL_LIST,
  },
  [namespace.detail]: {
    [ActionTypeValues.RESET_PAGE_STATE]: ActionTypeValues.RESET_PAGE_STATE,
    [ActionTypeValues.UPDATE_EMOJIES]: ActionTypeValues.UPDATE_EMOJIES,
    [ActionTypeValues.UPDATE_DELETEREASONS]: ActionTypeValues.UPDATE_DELETEREASONS,
    [ActionTypeValues.PUBLISH_SUCCESS]: ActionTypeValues.PUBLISH_SUCCESS,
    [ActionTypeValues.UPDATE_TOTALREPLYS]: ActionTypeValues.UPDATE_TOTALREPLYS,
  },
  [namespace.square]: {
    [ActionTypeValues.UPDATE_SQUARE_CHANNEL_LIST]: ActionTypeValues.UPDATE_SQUARE_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_SQUARE_ARTICAL_LIST]: ActionTypeValues.UPDATE_SQUARE_ARTICAL_LIST,
    [ActionTypeValues.UPDATE_SQUARE_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_SQUARE_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_SQUARE_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_SQUARE_CHANNEL_SORT_KEY_MAP,
  },
  [namespace.edit]: {},
  [namespace.consult]: {
    [ActionTypeValues.UPDATE_CONSULT_CHANNEL_LIST]: ActionTypeValues.UPDATE_CONSULT_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_CONSULT_ARTICAL_LIST]: ActionTypeValues.UPDATE_CONSULT_ARTICAL_LIST,
    [ActionTypeValues.UPDATE_CONSULT_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_CONSULT_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_CONSULT_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_CONSULT_CHANNEL_SORT_KEY_MAP,
  },
  [namespace.devices]: {
    [ActionTypeValues.UPDATE_DEVICES_CHANNEL_LIST]: ActionTypeValues.UPDATE_DEVICES_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_DEVICES_ARTICAL_LIST]: ActionTypeValues.UPDATE_DEVICES_ARTICAL_LIST,
    [ActionTypeValues.UPDATE_DEVICES_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_DEVICES_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_DEVICES_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_DEVICES_CHANNEL_SORT_KEY_MAP,
    [ActionTypeValues.UPDATE_DEVICES_SERIES_NAME]: ActionTypeValues.UPDATE_DEVICES_SERIES_NAME,
  },
  [namespace.device]: {
    [ActionTypeValues.UPDATE_DEVICE_CHANNEL_LIST]: ActionTypeValues.UPDATE_DEVICE_CHANNEL_LIST,
    [ActionTypeValues.UPDATE_DEVICE_ARTICAL_LIST]: ActionTypeValues.UPDATE_DEVICE_ARTICAL_LIST,
    [ActionTypeValues.UPDATE_DEVICE_CHANNEL_ACTIVE_KEYS]: ActionTypeValues.UPDATE_DEVICE_CHANNEL_ACTIVE_KEYS,
    [ActionTypeValues.UPDATE_DEVICE_CHANNEL_SORT_KEY_MAP]: ActionTypeValues.UPDATE_DEVICE_CHANNEL_SORT_KEY_MAP,
    [ActionTypeValues.UPDATE_DEVICE_NAME]: ActionTypeValues.UPDATE_DEVICE_NAME,
  },
  [namespace.profile]: {},
  [namespace.group]: {},
  [namespace.search]: {},
  [namespace.userCenter]: {},
};

export default actionTypes;

